import React, { useState, useEffect } from "react";
import { Modal, Button, CloseButton } from "react-bootstrap";
import { getTransactionEnquiry } from "../../../services/services";
import { getDisplayDate } from "../../../utils/helper";
import { Link, useLocation } from "react-router-dom";

const renderValue = (value) => {
  if (value === null || value === undefined) return <p>-</p>;
  if (Array.isArray(value)) {
    return value.map((item, index) => (
      <div key={index}>{renderValue(item)}</div>
    ));
  }
  if (typeof value === "object") {
    return Object.entries(value).map(([nestedKey, nestedValue]) =>
      nestedValue !== null && typeof nestedValue === "object" ? (
        <div key={nestedKey}>
          <strong>{nestedKey}:</strong>
          <div style={{ paddingLeft: "12px" }}>{renderValue(nestedValue)}</div>
        </div>
      ) : (
        <p key={nestedKey}>
          <strong>{nestedKey}:</strong> {String(nestedValue)}
        </p>
      ),
    );
  }
  return <p>{String(value)}</p>;
};

const TransactionViewModal = (props) => {
  const location = useLocation();
  const [formData, setFormData] = useState({});
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token_gen"));

    if (props.show) {
      setLoader(true);
      const response = getTransactionEnquiry(
        token?.access_token,
        props.transactionId,
      );

      response
        .then((res) => {
          setFormData(res.data || {});
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
        });
    } else setLoader(false);
  }, [props.show, props.transactionId]);

  const transactionDetail = formData?.transactionDetail || {};

  return (
    <>
      <Modal show={props.show} onHide={props.close} size="lg" centered>
        <Modal.Header>
          <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>
            Transaction View
          </Modal.Title>
          <CloseButton onClick={props.close} />
        </Modal.Header>
        <Modal.Body
          className="dashboard__transactionsModal"
          style={{ position: "relative", minHeight: "85px" }}
        >
          {loader ? (
            <div className="mainPreloaderMain" style={{ position: "absolute" }}>
              <div className="mainPreloader">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : formData?.transactionId ? (
            <div className="dashboard__transactionsModalProfile">
              <div className="dashboard__transactionsModalDetails">
                <div className="dashboard__transactionsModalBottom">
                  <ul>
                    <li>
                      <span>Transaction Id:</span>{" "}
                      <span
                        className="characterLimitProperty"
                        title={formData.transactionId}
                      >
                        {formData.transactionId}
                      </span>
                    </li>
                    <li>
                      <span>Customer Code:</span>
                      {location?.pathname.includes("customer-view") ? (
                        <span
                          className="characterLimitProperty"
                          title={formData.transactionId}
                        >
                          {formData?.customer?.[0]?.customercode}
                        </span>
                      ) : (
                        <Link
                          to={`/user-view/${formData?.customer?.customercode}`}
                          state={{ from: location?.state?.from }}
                        >
                          {formData?.customer?.customercode}
                        </Link>
                      )}
                    </li>

                    {transactionDetail.transactionType === "redeem" && (
                      <>
                        <li>
                          <span>Redemption Date:</span>{" "}
                          {getDisplayDate(
                            transactionDetail.transactionDate,
                            "MM-DD-YYYY",
                          ) !== "Invalid date"
                            ? getDisplayDate(transactionDetail.transactionDate)
                            : ""}
                        </li>
                        <li>
                          <span>Redemption Points:</span>{" "}
                          {transactionDetail.values
                            ? transactionDetail.values
                            : transactionDetail.amount}
                        </li>
                      </>
                    )}
                  </ul>
                </div>
              </div>
              {transactionDetail.transactionType === "refund"
                ? ""
                : transactionDetail.transactionType !== "redeem" && (
                    <div className="dashboard__transactionsModalDetails">
                      <div className="dashboard__transactionsModalTop">
                        <h2>Campaign Detail</h2>
                      </div>
                      <div className="dashboard__transactionsModalBottom">
                        {Array.isArray(formData?.campaigns) &&
                        formData?.campaigns.length ? (
                          formData?.campaigns.map((val, i) => (
                            <ul key={i}>
                              {val?.Type &&
                              val?.Type?.toUpperCase() === "POINT" ? (
                                <span>
                                  <li>
                                    <span>Campaign Code:</span> {val.Code}
                                  </li>
                                  <li>
                                    <span>Earned Points</span> {val.Value}
                                  </li>
                                </span>
                              ) : val?.Type &&
                                val?.Type?.toUpperCase() === "VOUCHER" ? (
                                <span>
                                  <li>
                                    <span>Campaign Code:</span> {val.Code}
                                  </li>
                                  <li>
                                    <span>Earned Type:</span> {val.Type}
                                  </li>
                                </span>
                              ) : (
                                <li>
                                  <span>Deducted Points {val.Type}:</span>{" "}
                                  {val.Value}
                                </li>
                              )}
                            </ul>
                          ))
                        ) : (
                          <>Campaign Not qualified</>
                        )}
                      </div>
                    </div>
                  )}
              {transactionDetail.transactionType !== "redeem" && (
                <div className="dashboard__transactionsModalDetails">
                  <div className="dashboard__transactionsModalTop">
                    <h2>Transaction Detail</h2>
                  </div>
                  <div className="dashboard__transactionsModalBottom">
                    <ul>
                      {transactionDetail.amount && (
                        <li>
                          <span>Transaction Amount:</span>{" "}
                          {transactionDetail.amount
                            ? transactionDetail.amount
                            : "0"}
                        </li>
                      )}
                      {transactionDetail.transactionamount && (
                        <li>
                          <span>Transaction Amount:</span>{" "}
                          {transactionDetail.transactionamount
                            ? transactionDetail.transactionamount
                            : "0"}
                        </li>
                      )}
                      {transactionDetail.transactionType ? (
                        <li>
                          <span>Transaction Type:</span>{" "}
                          {transactionDetail.transactionType}
                        </li>
                      ) : (
                        <li>
                          {" "}
                          <span>Transaction Type: purchase</span>{" "}
                        </li>
                      )}

                      {transactionDetail.activityType && (
                        <li>
                          <span>Activity Type:</span>{" "}
                          {transactionDetail.activityType}
                        </li>
                      )}

                      {transactionDetail.productType && (
                        <li>
                          <span>Product Type:</span>{" "}
                          {transactionDetail.productType}
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div
              style={{
                textAlign: "center",
                marginTop: "5%",
              }}
            >
              No Data Found
            </div>
          )}

          <div className="newStyleBlock">
            <h4>Transaction Request</h4>
            <ul className="newStyleList">
              <div>
                {formData?.transactionDetail &&
                typeof formData.transactionDetail === "object" ? (
                  <div className="dataLoop">
                    {Object.entries(formData.transactionDetail)
                      .filter(([key]) => key.toLowerCase() !== "others")
                      .map(([key, value]) => {
                        if (key === "orderDetails" && value?.sales?.length) {
                          return (
                            <div className="dataLoop__row" key={key}>
                              <div className="dataLoop__row__left">
                                <p>Product Details:</p>
                              </div>

                              <div className="dataLoop__row__right scrollable">
                                <table className="table table-bordered table-striped">
                                  <thead>
                                    <tr>
                                      <th>Product Name</th>
                                      <th>Quantity</th>
                                      <th>Price</th>
                                      <th>Total Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {value.sales.map((product, index) => (
                                      <tr key={index}>
                                        <td>
                                          <div style={{ fontWeight: 600 }}>
                                            {product.productName}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              color: "#666",
                                            }}
                                          >
                                            ERP ID: {product.productErpId}
                                          </div>
                                        </td>
                                        <td>{product.quantity}</td>
                                        <td>{product.price}</td>
                                        <td>
                                          {product.quantity * product.price}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          );
                        }
                        return (
                          <div className="dataLoop__row" key={key}>
                            <div className="dataLoop__row__left">
                              <p>{key}:</p>
                            </div>

                            <div className="dataLoop__row__right">
                              {key === "billLink" && value ? (
                                <Link to={value} title="Download Bill">
                                  <i className="fa-solid fa-download"></i>
                                </Link>
                              ) : (
                                renderValue(value)
                              )}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <p>No transaction details available</p>
                )}
              </div>
            </ul>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.close}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TransactionViewModal;
